<template>
  <div
    v-if="jobQuestion.value && jobQuestion.value.subspecialtyId"
    :key="`subspecialtyId_${jobQuestion.value.subspecialtyId}`"
    class="text-center d-flex flex-column align-items-center mt-2"
  >
    <span class="font-weight-bold v3_color_teal font_size_1125rem">
      Subspecialty
    </span>
    <span class="text-break">
      {{ subspecialtyName }}
    </span>
  </div>
</template>

<script>
import GetSubspecialtyOptionsMixin from '@/mixins/GetSubspecialtyOptionsMixin';

export default {
  name: 'PrePaywallIcoBrowserCriteriaResultSubspecialty',
  mixins: [GetSubspecialtyOptionsMixin],
  props: {
    jobQuestion: {
      validator: (prop) => typeof prop === 'object' || prop === null,
      required: true,
    },
  },
  computed: {
    subspecialty: function () {
      if (!this.jobQuestion.value || !this.jobQuestion.value.subspecialtyId)
        return null;
      return (
        this.$store.state.subspecialtyOptions.find(
          (s) => s.value === this.jobQuestion.value.subspecialtyId
        ) || {}
      ).subspecialty;
    },
    subspecialtyName: function () {
      return (this.subspecialty || {}).title;
    },
  },
};
</script>

<style scoped />
